import type { AppointmentType } from '@bb/domain/dist/types';
import { featureEnabled } from './featureFlagBrowserClient';

const correctShowingTypeLabel = (
  type: AppointmentType | 'APPOINTMENT' | 'ROUTE_STOP' | 'Information Request',
) => {
  if (!featureEnabled('agentInspectionRelabelFeature')) return type;
  switch (type) {
    case 'Agent Inspection':
      return 'Agent Inspection/Preview';
    default:
      return type;
  }
};

export default correctShowingTypeLabel;
